import React, { Component } from 'react';
import { Nav, NavDropdown } from 'react-bootstrap';
import { Link } from 'react-router-dom'
import { Fetcher } from "../Helpers/fetcher.js";
import { FaUsers, FaUserTie } from 'react-icons/fa';

import './index.css';
import { PERMS_KEY } from '../Helpers/perms.js';
import { isModuleAllowedForNonSubSuperAdmin } from '../Helpers/utils.js';
class Header extends Component {
	
	constructor(props) {
		super(props);
	this.state = {
		name: '',
		username: '',
		emailid: '',
		number: '',
		company: '',
		planName: '',
		creditsAvailable: '',
		ttsCredits : '',
		dashboardData:[],
		ttsPlansAllowed: true
	};
}
componentDidMount() {
		const apiPath = this.props.app.apiPath;
		const userId = this.props.app.userId;

		Fetcher.get(apiPath + '/api/obd/user/profile/' + userId)
			.then(res => {
				this.setState({
					name: res.name,
					username: res.username,
					emailid: res.emailid,
					number: res.number,
					company: res.company,
					planName: res.planName,
					creditsAvailable: res.credits,
					ttsCredits : res.ttsCredits
				})
			})
			.catch(err => { console.log('Error in fetching Users data', err) });

		// TTS Balance is only shown to reseller/end-user roles (see the render
		// below) -- gate it the same way the sidebar/user-list gate "TTS Plans",
		// since a reseller/user has no ACL of their own.
		if (this.props.app.role !== 'ROLE_SADMIN' && this.props.app.role !== 'ROLE_SUB_SADMIN' && this.props.app.role !== 'ROLE_SUSER') {
			isModuleAllowedForNonSubSuperAdmin(apiPath, userId, 'TTS Plans')
				.then(allowed => this.setState({ ttsPlansAllowed: allowed }));
		}

			Fetcher.get(apiPath + '/api/obd/dashboard/' + userId)
				.then(res => {
					this.setState({
						dashboardData: res.dbHeader
					})
				})
				.catch(err => { console.log('Error in fetching header Data', err) });
		}

		render(){
	return (
		<header className="app-header navbar">
			{this.props.app.userId && <div className="nav-desktop">
				<button onClick={this.props.toggleSidebar} className="navbar-toggler sidebar-toggler d-lg-none " type="button" data-toggle="sidebar-show">
					<span className="navbar-toggler-icon"></span>
				</button></div>}


			{this.props.app.userId && <div className="nav-mobile"> <a className="  navbar-brand" href={this.props.app.siteUrl}>
				{this.props.logo && <img className="navbar-brand-full" src={this.props.logo} alt=" Logo" />}
				{this.props.logo && <img className="navbar-brand-minimized" src={this.props.logo} width="30" height="30" alt=" Logo" />}
			</a><button onClick={this.props.toggleSidebar} className="navbar-toggler sidebar-toggler d-lg-none " type="button" data-toggle="sidebar-show">
					<span className="navbar-toggler-icon"></span>
				</button></div>}
			{this.props.app.userId && <Nav defaultActiveKey="/logout" as="ul">
			{(this.props.app.role === 'ROLE_SADMIN' || this.props.app.role === 'ROLE_SUB_SADMIN') && <>
											<Nav.Item as="li"><Nav.Link ><FaUserTie/> Total Resellers: {this.state.dashboardData.resellers}</Nav.Link></Nav.Item>
											<Nav.Item as="li"><Nav.Link><FaUsers/> Total End Users: {this.state.dashboardData.endUsers}</Nav.Link></Nav.Item>
							</>}
			    {this.props.app.role !== 'ROLE_SADMIN' && this.props.app.role !== 'ROLE_SUB_SADMIN' && this.props.app.role !== 'ROLE_SUSER' && this.state.ttsPlansAllowed && <Nav.Item as="li">
					<Nav.Link href="#">TTS Balance(Rs) : {this.state.ttsCredits}</Nav.Link>
				</Nav.Item>}
				{this.props.app.role !== 'ROLE_SADMIN' && this.props.app.role !== 'ROLE_SUB_SADMIN' && this.props.app.role !== 'ROLE_SUSER' && <Nav.Item as="li">
					<Nav.Link href="#">Voice Balance(Rs) : {this.state.creditsAvailable}</Nav.Link>
				</Nav.Item>}
				{(this.props.app.role === 'ROLE_SADMIN' || this.props.app.role === 'ROLE_ADMIN') &&
					<Nav.Item as="li">
						<Nav.Link href="/activity-logs">Activity Logs</Nav.Link>
					</Nav.Item>
				}
				{this.props.app.role === 'ROLE_USER' && <NavDropdown title="Sample Base Files" id="nav-dropdown-sample-files">
					<Nav.Link className='p-1' href="/assets/Normal_base.csv" download="Normal_base.csv">Base File (Normal)</Nav.Link>
					<Nav.Link className='p-1' href="/assets/Base_sample_advance.csv" download="Base_sample_advance.csv">Base File (Advance)</Nav.Link>
				</NavDropdown>}
				<NavDropdown title={"Welcome " + this.state.username} id="nav-dropdown">
					<Nav.Link className='p-1' href="/user-profile"> Profile</Nav.Link>
					<Nav.Link className='p-1' onClick={()=>{
						if(this.props.app.role==="ROLE_SUB_SADMIN"){
							localStorage.clear()
						}
						this.props.logOutUser()
					}} href=""> Logout</Nav.Link>
				</NavDropdown>
			</Nav>}
		</header>
	);
		}

}

export default Header;